<div class="container">

    <mat-dialog-content class="content-block">

        <app-stop-sign-icon></app-stop-sign-icon>

        <span class="error-message">Map All Shows Before Continuing</span>

        <span>{{unMappedCount}} shows not mapped</span>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="close-btn" mat-button (click)="onClose()">CLOSE</button>
    </mat-dialog-actions>
</div>